import { render, staticRenderFns } from "./UVideo.vue?vue&type=template&id=54d6f015&scoped=true&"
import script from "./UVideo.vue?vue&type=script&lang=js&"
export * from "./UVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6f015",
  null
  
)

export default component.exports